import axios from 'axios'

export const getIp = (params) => axios({
    methods: 'get',
    url: 'https://stock-data.nbd.com.cn/api/1/weather/ip_to_city.json'
})


export const getNewsList = (params) => axios({
    method:'get',
    params:params,
    url:'https://www.nbd.com.cn/caijing_canlender/events/one_day'
})


export const getStock = (params) => axios({
    method:'get',
    params:params,
    url:'https://nbd-app-gateway.nbd.com.cn/nbd-app-stock/index/important/v2'
})

//高德地图获取城市编码

export const getCityCode = (params) => axios({
    method:'get',
    params:params,
    url:'https://restapi.amap.com/v3/geocode/geo'
})

//高德地图 获取天气
export const getCityWeather = (params) => axios({
    method:'get',
    params:params,
    url:'https://restapi.amap.com/v3/weather/weatherInfo'
})

//极简

export const getJiJjian = (params) => axios({
    method:'get',
    params:params,
    url:'https://lianghua.nbd.com.cn/c/Data4/getMarktInfoForApp'
})

//今日新股申购

export const getTodayStock = (params) => axios({
    method:'get',
    params:params,
    url:'https://lianghua.nbd.com.cn/ipo/Company/getListForApp'
})

//私人订制 新闻

export const getPersonalArticle = (params) => axios({
    method:'get',
    params:params,
    url:'https://nbd-app-gateway.nbd.com.cn/nbd-app-stock/stock/focus/codes/articles?pageNum=0&pageSize=10'
})


// 每经热榜
export const getHotRank = (params) => axios({
    method:'get',
    params:params,
    url:'https://www.nbd.com.cn/news-rank-nr-h5/rank_index/rank'
})